<template>
  <el-container class = "home-container">
    <!--侧边栏-->
    <!--<el-aside :class="[isCollpase===false?'hidden-md-and-down':'']" :width="isCollpase?'64px':'217px'">-->
    <el-aside :width="isCollpase?'64px':'217px'">
      <el-header>
        <img src = "https://hnmykj.oss-cn-hangzhou.aliyuncs.com/xzcx/images/home/favicon.ico" alt = "">
        <span v-show = "!isCollpase">薪资查询助手</span>
      </el-header>
      <!--侧边栏菜单区域-->
      <el-menu
        background-color = "#304156"
        text-color = "#fff"
        active-text-color = "#409EFF"
        :unique-opened = "true"
        :collapse = isCollpase
        :collapse-transition = "false"
        :router = "true"
        :default-active = "activePath">
        <el-submenu :index = "index+''" v-for = "(item,index) in menulist" :key = "index">
          <!-- 一级菜单的模板区域 -->
          <template slot = "title">
            <!--图标-->
            <i :class = "iconObj[item.code]"></i>
            <!--文本-->
            <span>{{ item.menuName }}</span>
          </template>
          <el-menu-item @click = "saveNavState('/'+subItem.menuUrl,item,subItem)" :index = "'/'+subItem.menuUrl"
                        v-for = "(subItem,subIndex) in item.children" :key = "subIndex">
            <template slot = "title">
              <!--图标-->
              <i class = "el-icon-menu"></i>
              <!--文本-->
              <span>{{ subItem.menuName }}</span>
            </template>
          </el-menu-item>
        </el-submenu>
      </el-menu>


      <div style="margin-top: 100%;margin-left: 20%" >
        <el-button icon="el-icon-phone-outline" size="small" @click="drawer = true" type="success">微信客服</el-button>
      </div>
    </el-aside>
    <!--右侧区域-->
    <el-container>
      <!--头部区域-->
      <el-header>
        <div class = "el-icon-s-unfold toggle-button" @click = "toggleCollpase"></div>
        <el-breadcrumb separator-class = "el-icon-arrow-right">
          <el-breadcrumb-item :to = "{ path: '/home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item v-show="breadcrumbItem">{{ breadcrumbItem }}</el-breadcrumb-item>
          <el-breadcrumb-item v-show="breadcrumbSubItem">{{ breadcrumbSubItem }}</el-breadcrumb-item>
        </el-breadcrumb>



<!--         <el-button type = "danger" @click = "logout">退出</el-button>-->




        <el-dropdown  class="avatar-container right-menu-item hover-effect" trigger="click">
          <div style="margin-right: 70px">
            <svg t="1708698513045"  @click="$router.push('/order')" class="user-avatar" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10817" width="228" height="228"><path d="M438.57 832.59a56.44 56.44 0 1 1-56.44-56.44 56.43 56.43 0 0 1 56.44 56.44z m334-56.44A56.44 56.44 0 1 0 829 832.59a56.43 56.43 0 0 0-56.42-56.44z m186.3-405.66l-56.72 340.25a66.48 66.48 0 0 1-65.58 55.55H318.15a66.49 66.49 0 0 1-65.59-55.55l-61.5-369L165.3 189.7l-82.19 13.93a13 13 0 0 1-15-10.68l-3.71-21.73a13 13 0 0 1 10.67-15l124.16-21a13 13 0 0 1 15 10.68l5.85 34.58 19.12 112.59h654.09a66.49 66.49 0 0 1 65.58 77.42zM383.14 448a26 26 0 0 0 26 26h79.94a26 26 0 1 0 0-51.95h-79.96A26 26 0 0 0 383.14 448z m386 166.8a26 26 0 0 0-26-26h-333a26 26 0 0 0-26 26 26 26 0 0 0 26 26h333a26 26 0 0 0 26-26z" fill="#D786EA" p-id="10818"></path><path d="M893.29 293.07H503.36c-135.61 78.25-226.88 224.74-226.88 392.56a455.91 455.91 0 0 0 5.36 69.87 66.29 66.29 0 0 0 36.31 10.79h518.42a66.48 66.48 0 0 0 65.58-55.55l56.72-340.25a66.49 66.49 0 0 0-65.58-77.42zM409.12 422h79.94a26 26 0 1 1 0 51.95h-79.94a26 26 0 1 1 0-51.95z m360 192.78a26 26 0 0 1-26 26h-333a26 26 0 0 1-26-26 26 26 0 0 1 26-26h333a26 26 0 0 1 26 26z" fill="#CA6EE0" p-id="10819"></path><path d="M473.36 588.78h269.76a26 26 0 0 1 26 26 26 26 0 0 1-26 26H449.93a450.72 450.72 0 0 0-27.71 125.56h414.35a66.48 66.48 0 0 0 65.58-55.55l56.72-340.25a67.47 67.47 0 0 0 0.81-14.8 455.39 455.39 0 0 0-85.83-8.13c-173.66-0.05-324.49 97.7-400.49 241.17z" fill="#C65EDB" p-id="10820"></path><path d="M713.51 588.78h29.61a26 26 0 0 1 26 26 26 26 0 0 1-26 26h-79.74a452.44 452.44 0 0 0-73.12 125.56h246.31a66.48 66.48 0 0 0 65.58-55.55l38.27-229.57a451.22 451.22 0 0 0-226.91 107.56z" fill="#BD50D3" p-id="10821"></path><path d="M368.44 327.7c7.22 7.07-19.49 23.33-45.65 50s-41.86 53.74-49.09 46.66 3.66-38.84 29.82-65.54 57.7-38.2 64.92-31.12z" fill="#FFFFFF" p-id="10822"></path></svg>
          </div>


          <el-dropdown-menu></el-dropdown-menu>
        </el-dropdown>



       <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">

        <div class="avatar-wrapper">
          <img src="http://wssbw-images.oss-cn-hangzhou.aliyuncs.com/trademark/web/9d6c24c7-e29e-4c81-8000-c3f08a961d66.png" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
		  </el-dropdown>

      </el-header>
      <!--右侧内容主体区域-->
      <el-main>
        <!--路由占位符-->
        <router-view></router-view>

        <div style="position:relative;"  @click="drawer = true">
          <div class="button-box" draggable="false" >
            <el-tooltip class="item" effect="dark" content="点击联系客服"  placement="top-start"  >
              <el-image
                style="width: 50px; height: 50px;  border: 0px solid #ddd;"
                :src="url"
              ></el-image>
            </el-tooltip>
          </div>
        </div>


        <el-drawer
          title="客服反馈"
          :visible.sync="drawer"
          :direction="direction">
          <el-card  :body-style="{  padding: '0px',paddingTop:'20px' ,paddingBottom:'150px'}"  align="center"  >
            <el-image
              style="width: 200px; height: 200px"
              src="https://hnmykj.oss-cn-hangzhou.aliyuncs.com/xzcx/images/poster/1651153633867.jpg"
             ></el-image>

            <el-alert
              title="Hi，我是你的薪资助手，如需帮助可以微信扫描联系我"
              type="success"
              show-icon>
            </el-alert>

            <el-alert
              title="产品咨询,售后服务,使用答疑,服务续订,发票合同"
              type="success"
              show-icon >
            </el-alert>

            <el-form ref="form" :model="form" label-width="80px" style="margin-top: 20px;width: 90%;margin-top: 40px">
              <el-input type="textarea"  :rows="4" placeholder="如果您在使用产品有遇到任何问题或者有对产品功能有更好的意见,欢迎反馈给我们" v-model="form.feedbackStr"></el-input>
              <el-form-item label=""/>
              <el-form-item>
                <el-button type="primary"  @click="onSubmit">反馈</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-drawer>




      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      // 左侧菜单数据
      menulist: [],
      companyId:0,
      iconObj: {
        '125':'iconfont icon-users',
        '103':'iconfont icon-tijikongjian',
        '101':'iconfont icon-shangpin',
        '102':'iconfont icon-danju',
        '145':'iconfont icon-baobiao'
      },
      isCollpase: false,
      // 被激活的链接地址
      activePath: '',
      // 面包屑文字
      breadcrumbItem: '',
      breadcrumbSubItem: '',
      url:'https://hnmykj.oss-cn-hangzhou.aliyuncs.com/xzcx/images/poster/weixin2024.png',
      drawer: false,
      direction: 'rtl',
      form:{
        feedbackStr:''
      }
    }
  },
  created() {
    this.getMenuList()
    this.activePath = window.localStorage.getItem('activePath')

    this.companyId = JSON.parse( window.localStorage.getItem('company')).companyId;
  },
  methods: {
    logout() {
      window.localStorage.clear()
      this.$router.push('/login')
    },
    // 获取左侧所有的菜单
    async getMenuList() {
      const { data: res } = await this.$http.get('role/getRoleMenuList')
      if (res.code !== '10000') {
        return this.$message.error(res.msg)
      } else {
        this.menulist = res.data
      }
      // console.log('获取左侧所有的菜单------')
      // console.log(res)
    },
    // 点击按钮，切换菜单的折叠与展开
    toggleCollpase() {
      this.isCollpase = !this.isCollpase
    },
    // 保存链接的激活状态
    saveNavState(activePath, item, subItem) {
      window.localStorage.setItem('activePath', activePath)
      this.activePath = activePath
      // 更新面包屑导航文字
      this.breadcrumbItem = item.authName
      this.breadcrumbSubItem = subItem.authName
    },
    async onSubmit(){

      if(this.form.feedbackStr==''){
        return ;
      }

      const { data: res } = await this.$http.post('feedback/addFeedback',this.form)   //get参数用params获得
      if(res.code !== '10000') {
        return this.$message.error(res.msg);
      }

      this.form.feedbackStr='';
      this.$notify({
        title: '成功',
        message: '反馈成功!',
        type: 'success'
      });
    },
  }
}
</script>

<style lang = "less" scoped>
.home-container {
  height: 100%;
}

.user-avatar{
  width: 30px;
  height: 30px;
}
.el-header {
  background-color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 20px;

  .el-breadcrumb{
    margin-left: 20px;
  }

  .el-button {
    position: absolute;
    right: 20px;
  }

  .el-dropdown{
    position: absolute;
    right: 20px;
  }

}

.el-aside {
  background-color: #304156;
  transition: all 0.3s;
  img {
    width: 32px;
    height: 32px;
  }

  .el-header {
    background-color: #304156;
    color: white;
    font-size: 16px;
    justify-content: flex-start;

    span {
      margin-left: 45px;
      position: absolute;
    }
  }
}

.el-main {
  background-color: #F0F2F5;
}

.el-menu {
  border-right: none;
}

.iconfont {
  margin-right: 10px;
}

.toggle-button {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.button-box {
  width: 70px;
  /*height: 70px;*/
  /*border-radius: 50%;*/
  position: fixed;
  bottom: 90px;
  right: 20px;

  padding-left: 15px;
  padding-top: 8px;
  cursor: pointer;
  opacity: 1;
  z-index: 888;
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue